import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ProjectRole } from 'common/types';
import service from '@/service';
import { SETTING_KEY } from '@/constants';
import { RootState } from './rootReducer';
import { AppThunk } from '.';

export enum PROJECT_TYPE {
  PLatform = 'PLATFORM',
  Project = 'PROJECT',
}

type Project = {
  tgProjectId: number; // 天工项目id
  projectId: string;
  projectCode: string;
  projectType: PROJECT_TYPE;
  projectName?: string;
};

type InitialState = {
  // 导航栏相关
  activeSetting: SETTING_KEY;
  allProjects: Array<Project>;
  // 项目列表
  projects: Array<Project>;
  activeProject?: Project;
};

const initialState: InitialState = {
  activeSetting: SETTING_KEY.USER,
} as InitialState;

const settings = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setActiveSetting(state, { payload }: PayloadAction<SETTING_KEY>) {
      state.activeSetting = payload;
      const projects = state.allProjects || [];
      state.projects = projects;
      const isNoActiveProject = !projects?.find(({ projectCode }) => projectCode === state.activeProject?.projectCode);
      if (isNoActiveProject) {
        state.activeProject = projects?.[0];
      }
    },
    setActiveProject(state: InitialState, { payload }: PayloadAction<string>) {
      const project = state.projects.find(({ projectId }) => projectId === payload);
      state.activeProject = project;
    },
    setProjects(state, { payload }: PayloadAction<Array<Project>>) {
      const allProjects = payload;
      state.allProjects = allProjects;
      state.projects = allProjects;
      const isNoActiveProject = !allProjects?.find(
        ({ projectCode }) => projectCode === state.activeProject?.projectCode,
      );
      if (isNoActiveProject) {
        state.activeProject = allProjects?.[0];
      }
    },
  },
});

export const { setActiveSetting, setActiveProject, setProjects } = settings.actions;

export const selectActiveProject = (state: RootState): Project | undefined => state.settings.activeProject;
export const selectSettings = (state: RootState) => state.settings;

export const getProjectList = (): AppThunk => async (dispatch, getState) => {
  const projects = await service.userSetting.getPublishTaskProjects(ProjectRole.Admin);
  dispatch(
    setProjects(
      projects.data.items?.map(project => {
        const projectId = project?.uniqueId?.toString();
        return { ...project, projectId };
      }),
    ),
  );
};

export default settings.reducer;
